/** The catalog records' one `custom_id` rule (plan O11), the console's half of the backend's
 *  `apiv2/lib/console/catalog_fields/identity.py`: `''`, whitespace and null are the same
 *  value — "no external ID" — and values compare stripped. The server reads every
 *  `custom_id` baseline through it (`normalize_custom_id`), so a baseline the console reads
 *  from a detail payload must too — else a stored `''` or `' FH-1 '` would not equal the
 *  edit context's value, and the draft would see a change nobody made. */

/** The comparable form: the stripped text, and null for null, `''` and whitespace. */
export function normalizeCustomId(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined) return null;
  const value = raw.trim();
  return value === '' ? null : value;
}
